<template>
  <div v-if="column.type == 'upload'" :class="row._type == 'edit' ? 'downloadEdit' : ''">
    <kye-upload
      :show-file-list="column.option && column.option.showList ? column.option.showList : false"
      :code="column.option && column.option.code ? column.option.code : ''"
      :disabled="setDisabled(column, row)"
      :id="getBzid()"
      btn-type="text"
      btn-icon=""
      :btn-text="column.option && column.option.btnText ? column.option.btnText : '上传文件'"
      :limit="column.option && column.option.limit ? column.option.limit : undefined"
      :size="column.option && column.option.size ? column.option.size : undefined"
      :list-type="column.option && column.option.listType ? column.option.listType : 'text'"
      :accept="column.option && column.option.accept ? column.option.accept : ['excel', 'word', 'pdf', 'image', 'zip']"
      v-model="arr"
      @success="e => uploadSuccess(e, tIndex, row, column)">
      <el-button size="small" type="primary">点击上传</el-button>
    </kye-upload>
  </div>
  <div v-else-if="column.type == 'download'" :class="row._type == 'edit' ? 'downloadEdit' : ''">
    <span :class="text && text.length > 0 ? '' : 'toDownload'" @click="toDownload" class="kye-label-click">下载</span>
  </div>
  <div v-else-if="row.hasOwnProperty(column.key + 'MaskSec') && !row[column.key]">
    <span>{{ getMaskSec() }}</span>
  </div>
  <div v-else :class="row._type == 'edit' ? 'formItemEdit' : 'formItemText'" style="display: flex">
    <span
      class="kye-label-click"
      @click="toDecrypt"
      v-if="row[`${column.key}Mask`] || row[`${column.key}Virtual`]"
      style="line-height: 28px"
      >解密</span
    >
    <!-- 2022-08-31增加 type: render 类型。用于解决自定义render会被强行加上kye-edit-table__column-bg类与自定义组件不能设置 rules的问题 -->
    <div
      class="tableContent"
      v-if="column.type && column.type != 'text' && column.type !== 'render' && row._type == 'edit'">
      <el-input
        v-if="column.type == 'input'"
        :clearable="!!column.clearable"
        :disabled="setDisabled(column, row)"
        :maxlength="column.maxlength"
        :minlength="column.minlength"
        :placeholder="column.placeholder"
        v-bind="column.attr || {}"
        v-model="text"
        v-on:keyup.enter.native="inputEnter(tIndex, row, column)"
        @focus="inputFocus(tIndex, row, column)"
        @clear="clearEdit(tIndex, row, column)"
        @blur="inputBlur(tIndex, row, column)"
        @change="inputChange(tIndex, row, column)"
        @input="input(tIndex, row, column)" />
      <kye-number
        v-else-if="column.type == 'input-number'"
        :clearable="!!column.clearable"
        :disabled="setDisabled(column, row)"
        :symbol="column.symbol"
        :unit="setUnit(column, row)"
        :precision="column.precision"
        :max="column.max"
        :min="column.min"
        :maxlength="column.maxlength"
        :minlength="column.minlength"
        :placeholder="column.placeholder"
        v-bind="column.attr || {}"
        v-model="text"
        @clear="clearEdit(tIndex, row, column)"
        @blur="inputBlur(tIndex, row, column)"
        @input="inputChange(tIndex, row, column)" />
      <!--2024-01-10 checkbox 不支持校验，本身就是true或者false -->
      <el-checkbox
        v-else-if="column.type == 'checkbox'"
        :disabled="setDisabled(column, row)"
        :true-label="column.trueLabel || 1"
        :false-label="column.falseLabel || 0"
        v-model="text"
        @change="inputChange(tIndex, row, column)" />
      <e-select
        v-else-if="column.type == 'select'"
        :disabled="setDisabled(column, row)"
        :model="text"
        :index="tIndex"
        :column="column"
        :row="row"
        v-bind="column.attr || {}"
        @clear="
          select => {
            clearSelectEdit(tIndex, row, column, select)
          }
        "
        @selectRemote="selectRemote" />
      <!-- 2022-09-01 由于key-date-picker中未设置picker-options存入attrs中 所以导致 :picker-options在此处不生效，兼容写法，添加rangePickerOptions -->
      <kye-date-picker
        v-else-if="column.type == 'date-picker'"
        :clearable="!!column.clearable"
        :disabled="setDisabled(column, row)"
        v-model="text"
        :format="column.option && column.option.format ? column.option.format : ''"
        :type="column.option && column.option.type ? column.option.type : 'datetime'"
        :value-format="column.option && column.option.valueFormat ? column.option.valueFormat : ''"
        :picker-options="column.option && column.option.pickerOptions ? column.option.pickerOptions : {}"
        :rangePickerOptions="
          column.option && !column.option.pickerOptions && column.option.rangePickerOptions
            ? column.option.rangePickerOptions
            : {}
        "
        :default-time="column.option && column.option.defaultTime ? column.option.defaultTime : ''"
        :default-value="column.option && column.option.defaultValue ? column.option.defaultValue : ''"
        :placeholder="column.placeholder ? column.placeholder : ' '"
        @clear="clearEdit(tIndex, row, column)"
        @input="datetimeChange(tIndex, row, column)" />
      <search-tips
        v-else-if="column.type == 'search-tips'"
        :index="tIndex"
        :column="column"
        :data="row"
        :model="text"
        :disabled="setDisabled(column, row)"
        :width="column.tipsWidth || '200px'"
        @change="bindChangeText"
        @clear="clearEdit(tIndex, row, column)"
        @select="searchTipsSelect"
        @close="searchTipsClose" />
      <kye-time-select
        v-else-if="column.type == 'time-select'"
        v-model="text"
        :disabled="setDisabled(column, row)"
        :clearable="!!column.clearable"
        :picker-options="
          column.options && column.options.pickerOptions
            ? column.options.pickerOptions
            : {
                start: '07:00',
                step: '00:15',
                end: '22:30'
              }
        "
        :placeholder="column.placeholder ? column.placeholder : ' '"
        @clear="clearEdit(tIndex, row, column)"
        @change="timeSelectChange(tIndex, row, column)" />
      <kye-time-picker
        v-else-if="column.type == 'time-picker'"
        v-model="text"
        :clearable="!!column.clearable"
        :disabled="setDisabled(column, row)"
        :format="column.option && column.option.format ? column.option.format : 'HH:mm:ss'"
        :picker-options="
          column.options && column.options.pickerOptions
            ? column.options.pickerOptions
            : { selectableRange: '00:00:00 - 23:59:59' }
        "
        :placeholder="column.placeholder"
        @clear="clearEdit(tIndex, row, column)"
        @change="timePickerChange(tIndex, row, column)" />
      <kye-area-remote
        v-else-if="column.type == 'area'"
        v-model="text"
        :level="column.level ? column.level : 5"
        @change="
          data => {
            areaRemoteChange(tIndex, row, column, data)
          }
        " />
      <kye-input-money
        v-else-if="column.type == 'input-money'"
        :showUnit="(column.attr && column.attr.showUnit === true) || false"
        :disabled="setDisabled(column, row)"
        v-model="text"
        v-bind="column.attr || {}"
        :placeholder="column.placeholder"
        @clear="clearEdit(tIndex, row, column)"
        @blur="inputBlur(tIndex, row, column)"
        @change="inputMoneyChange(tIndex, row, column)"
        @input="input(tIndex, row, column)"
        @focus="inputFocus(tIndex, row, column)" />
    </div>
    <div class="tableContent tableContentText" v-else :class="column.click ? 'kye-label-click' : ''">
      <cell-render
        v-if="column.render && typeof column.render === 'function'"
        :index="tIndex"
        :row="row"
        :value="text"
        :column="column"
        :crender="column.render" />
      <kye-button
        @click="clickRow(tIndex, row, column.click)"
        v-else-if="column.click"
        type="text"
        :disabled="setDisabled(column, row)"
        :auth="column.auth">
        {{ getButtonText(column.buttonText, row, column.key) }}
      </kye-button>
      <tips
        @click="clickRow(tIndex, row, column.click)"
        v-else
        :align="column.align"
        :width="column.width"
        :placeholder="column.placeholder"
        :content="format(column, text, row)" />
    </div>
  </div>
</template>

<script>
  import eSelect from './select'
  import cellRender from './cell-render'
  import searchTips from './search-tips'
  import tips from './tips'
  import { decrypt, getModalPageName, getModelValue } from 'public/utils'
  export default {
    name: 'edit-content',
    components: {
      eSelect,
      cellRender,
      searchTips,
      tips
    },
    props: {
      column: {
        type: Object,
        default() {
          return {}
        }
      },
      row: {
        type: Object,
        default() {
          return {}
        }
      },
      tIndex: {
        type: Number,
        default() {
          return 0
        }
      },
      val: {
        type: [Number, String, Array, Object, Boolean],
        default() {
          return ''
        }
      },
      triggerEventManager: Function
    },
    data() {
      return {
        text: '',
        arr: [],
        inputTimer: null
      }
    },
    methods: {
      // 格式化数据
      format(column, val, row) {
        let value = val
        if (column.filter && (value || value === 0)) {
          if (column.filter.type && column.filter.args) {
            let func = this.$filter[column.filter.type]
            if (func) {
              value = func(value, ...column.filter.args)
            }
          } else if (this.$filter[column.filter]) {
            let func = this.$filter[column.filter]
            if (func) {
              value = func(value)
            }
          } else if (typeof column.filter === 'function') {
            value = column.filter(value, row)
          }
        }
        let type = Object.prototype.toString.call(value)
        if (type.indexOf('Null') > -1 || type.indexOf('Undefined') > -1) {
          value = ''
        }
        return value + ''
      },
      // 输入框改变事件
      inputChange(index, row, column) {
        clearInterval(this.inputTimer)
        let text = this.text
        if (typeof text === 'string') text = text.trim()
        this.$emit('inputChange', { index, column, text })
        this.$props.triggerEventManager('inputChange', { index, column })
      },
      inputFocus(index, row, column) {
        let text = this.text
        if (typeof text === 'string') text = text.trim()
        this.$emit('inputFoucs', { index, column, text }, row)
      },
      inputMoneyChange(index, row, column) {
        // 最大最小值在blur事件处理，用nextTick包裹下
        this.$nextTick(() => {
          this.inputChange(index, row, column)
        })
      },
      setUnit(col, row) {
        if (col.unit && typeof col.unit === 'function') {
          return col.unit(row)
        }
        return col.unit
      },
      input(index, row, column) {
        column.input && column.input(index, row, this.text)
        this.$props.triggerEventManager('elInput', { index, row, column, data: this.text })
      },
      // 输入框失去焦点事件
      inputBlur(index, row, column) {
        column.blur && column.blur(index, row, this.text)
        this.$props.triggerEventManager('inputBlur', { index, row, column, data: this.text })
      },
      // checkbox改变事件
      checkboxChange(index, row, column) {
        column.change && column.change(index, column, this.text)
      },
      // datetimeChange 事件
      datetimeChange(index, row, column) {
        this.$emit('datetimeChange', { index, column, text: this.text })
        this.$props.triggerEventManager('datetimeChange', { index, column })
      },
      // 远程select获取选择
      selectRemote(prams) {
        this.$emit('selectChange', prams)
        const { index, column } = prams
        this.$props.triggerEventManager('selectChange', { index, column })
      },
      // 行点击事件
      clickRow(index, row, fn) {
        fn && fn(index, row)
      },
      inputEnter(index, row, col) {
        col.enter && col.enter(index, row, col)
      },
      // 选择行事件
      selectRow(row) {
        let obj = { ...row }
        let index = obj._tIndex
        this.$emit('selectRow', index, obj)
      },
      selectionRow(val) {
        let arr = val.map(item => ({ ...item }))
        arr.sort((old, fresh) => fresh._tIndex - old._tIndex)
        this.$emit('checkboxRow', arr)
      },
      rowClick(row, event, column) {
        // if (this.showCheckbox) {
        //   this.$refs.multipleTable.toggleRowSelection(row)
        // }
      },
      // 输入框点击的时候会阻止冒泡
      disablRowClick(e) {
        e.stopPropagation()
      },
      searchTipsSelect(val) {
        this.$emit('searchTipsSelect', val)
        let { index, column } = val
        this.$props.triggerEventManager('searchTipsSelect', { index, column })
      },
      searchTipsClose(val) {
        this.$emit('searchTipsClose', val)
        let { index, column } = val
        this.$props.triggerEventManager('searchTipsClose', { index, column })
      },
      // time select change
      timeSelectChange(index, row, column) {
        this.$emit('inputChange', { index, column, text: this.text })
        this.$props.triggerEventManager('inputChange', { index, row, column })
      },
      timePickerChange(index, row, column) {
        this.$emit('inputChange', { index, column, text: this.text })
        this.$props.triggerEventManager('inputChange', { index, row, column })
      },
      clearEdit(index, row, column) {
        column.clear && column.clear(index, row, column)
      },
      clearSelectEdit(index, row, column, select) {
        this.$emit('clearSelectEdit', { index, row, column, select })
      },
      uploadSuccess(data, index, row, column) {
        column.change && column.change(index, row, data)
        this.$props.triggerEventManager('uploadSuccess', { index, row, column })
      },
      areaRemoteChange(index, row, column, data) {
        column.change && column.change(index, row, data)
        this.$props.triggerEventManager('areaRemoteChange', { index, row, column, data: this.text })
      },
      getButtonText(buttonText, row, key) {
        let str = ''
        if (buttonText) {
          str = typeof buttonText === 'function' ? buttonText(row) : buttonText
        } else {
          str = row[key]
        }
        return str
      },
      setDisabled(col, row) {
        if (col.disabled && typeof col.disabled === 'function') {
          return col.disabled(row)
        }
        return !!col.disabled
      },
      async toDecrypt() {
        const { column, row, tIndex } = this
        const type = row.hasOwnProperty(`${column.key}Mask`) ? 'Mask' : 'Virtual'
        const res = await decrypt(
          {
            dataId: row[column.bizIdKey] || getModelValue(row, this.bizIdKey) || '11', // 当前数据唯一标识
            moduleCode: column.moduleCode,
            fieldName: column.fieldName || column.key,
            fieldContent: row[column.key + type],
            fieldNameStr: column.label || '',
            buttonName: getModalPageName(this)
          },
          type.toLocaleLowerCase()
        )
        if (res !== null) {
          // 避免二次解密
          if (row.hasOwnProperty(`${column.key}${type}`)) {
            delete row[`${column.key}${type}`]
          }
          this.text = res || ''
          this.$emit('decrypt', { index: tIndex, column, text: this.text })
        }
      },
      changText() {
        this.text = this.row[this.column.key]
      },
      bindChangeText(val) {
        if (!this.column.ids) {
          this.row[this.column.key] = val
        }
      },
      toDownload() {
        !!this.text && window.erpOpen(this.text)
      },
      getBzid() {
        const { column, row } = this
        let id = row._uuid
        if (column.option && column.option.id) {
          id = typeof column.option.id === 'function' ? column.option.id(row) : column.option.id
        }
        return id
      },
      getMaskSec() {
        return window.__ERPGLOABLECONFIG__.maskSec || '✽✽✽'
      }
    },
    created() {
      this.changText()
    },
    watch: {
      val() {
        this.changText()
      }
    }
  }
</script>

<style lang="scss" scoped>
.toDownload {
  color: #cccccc;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-edit-table/edit-form.vue